/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon16Light = forwardRef('GovKoRosreestrIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.5a5.5 5.5 0 1 1 5.98 5.48A5.5 5.5 0 0 1 3.5 16a.5.5 0 0 1-.5-.5v-10ZM4.027 5A4.502 4.502 0 0 1 8 1.027V5H4.027ZM4 10V6h4v4H4Zm0 1v3.973A4.502 4.502 0 0 0 7.973 11H4Zm8.973-5A4.502 4.502 0 0 1 9 9.973V6h3.973ZM9 1.027A4.502 4.502 0 0 1 12.973 5H9V1.027Z" })));
});
